import React, { useEffect, useState } from 'react';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Pagination from 'components/Pagination';
import ToggleSwitch from '../../../components/ToggleSwitch/ToggleSwitch';
import QueueContainer from './QueueContainer';

import PauseService from '../service';

import {
  Input,
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  CardBody,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Label,
  Badge
} from 'reactstrap';

import {
  icon_column_style,
  individual_column_style,
  individual_header_style,
  individual_icon_header_style
} from '../../../assets/styles/table_custom_style';
import ReactLoader from 'components/Loader';

const PauseList = () => {
  const [pauses, setPauses] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showDisable, setShowDisable] = useState(false);
  const [searchPauses, setSearchPauses] = useState();

  const getPauses = (selectedPage = 1, search = '') => {
    setLoading(true);
    PauseService.getAllSeach(selectedPage, 10, search, showDisable)
      .then((response) => {
        const pauseList = response.data.data;
        const quantity = response.data.totalRegisters;
        setPauses(pauseList);
        setQuantity(quantity);
        setLoading(false);
      })
      .catch((err) => {
        //const { data } = error.response;
        toast.error(err.response.data.message || 'Erro ao listar pausas!', {
          autoClose: 3000,
          closeOnClick: true
        });
        setLoading(false);
      });
  };

  useEffect(getPauses, [showDisable]);

  const toggleDisable = (id, disable) => {
    if (!disable) {
      disablePause(id);
    } else {
      recoveryPause(id);
    }
  };

  const disablePause = (id) => {
    if (!window.confirm('Tem certeza que deseja desabilitar a pausa?')) return;
    PauseService.delete(id)
      .then(() => {
        toast.info('Pausa desabilitada com sucesso!', {
          autoClose: 3000,
          closeOnClick: true
        });

        getPauses();
      })
      .catch((err) => {
        toast.error(
          err.response.data.message || 'Ops, algo errado aconteceu!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      });
  };

  const recoveryPause = (id) => {
    PauseService.recovery(id)
      .then(() => {
        toast.info('Pausa recuperada com sucesso!', {
          autoClose: 3000,
          closeOnClick: true
        });
        getPauses(activePage);
      })
      .catch((err) => {
        toast.error(err.response.data.message || 'Ops algo errado aconteceu!', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const getPausesSearch = (event, selectedPage = 1) => {
    setSearchPauses(event.target.value);
    if (searchPauses) {
      getPauses(selectedPage, event.target.value);
    }
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    getPauses(page);
  };

  const handleShowDisableds = (value) => {
    setShowDisable(value);
    if (value === false) setActivePage(1);
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/pause/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row className="mt-3 mx-2">
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Pausa</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="8">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Pausa"
                          type="text"
                          onChange={(event) => getPausesSearch(event)}
                        />
                      </InputGroup>
                    </Col>
                    <Col md="4" className="text-right mt-2">
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            checked={showDisable}
                            onChange={() => handleShowDisableds(!showDisable)}
                          />
                          <span>Mostrar desabilitadas</span>
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={pauses}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'description',
                      text: 'Descrição',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'time_alert',
                      text: 'Tempo de Alerta (Segundos)',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'active',
                      text: 'Ativa',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      formatter: (rowContent, row) => {
                        return row.active === true ? 'Sim' : 'Não';
                      }
                    },
                    {
                      dataField: 'queues',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Filas',
                      sort: true,
                      // eslint-disable-next-line react/display-name
                      formatter: (rowContent, row) => {
                        return (
                          <QueueContainer>
                            {rowContent.map(({ name }, index) => {
                              return (
                                <Badge
                                  color="info"
                                  key={index}
                                  style={{ margin: 3 }}
                                >
                                  {name}
                                </Badge>
                              );
                            })}
                          </QueueContainer>
                        );
                      }
                    },
                    {
                      dataField: 'disable',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Habilitar / Desabilitar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <ToggleSwitch
                            checked={!row.disable}
                            id={row.name}
                            onChange={() => toggleDisable(row.id, row.disable)}
                          />
                        );
                      }
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Link to={'/admin/pause/form/' + row.id}>
                            <Button color="info" size="sm">
                              <li className="fas fa-user-edit"></li>
                            </Button>
                          </Link>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default PauseList;
